export default __webpack_public_path__ + "static/media/17.4963c82e.jpeg";